const PLACEHOLDER = 'No description available'

type Props =
    | {
          bodyStyle?: string | null
          color?: string | null
          make?: string | null
          model?: string | null
          trim?: string | null
          year?: string | null
      }
    | undefined
    | null

export const formatMakeModelYear = (asset: Props): string => {
    if (!asset) {
        return PLACEHOLDER
    }

    const { bodyStyle, color, make, model, year } = asset
    const modYear = year === '0' ? null : year
    // const items = [modYear, make, model, color, trim, bodyStyle].filter(
    const items = [modYear, make, model, color, bodyStyle].filter(
        (i) => typeof i === 'string' && i.toLowerCase() !== 'null' && i.toLowerCase() !== 'undefined',
    )

    return items.length ? items.join(' ') : 'No description available'
}
